module.exports = __webpack_public_path__ + "img/监控及逃生路线.2da14881.png";